import {
  Backdrop as MuiBackdrop,
  BackdropProps,
  CircularProgress,
} from "@material-ui/core";
import React from "react";

export const Backdrop = (props: BackdropProps) => (
  <MuiBackdrop {...props}>
    <CircularProgress color="secondary" />
  </MuiBackdrop>
);
